import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Hero from './components/Hero';
import ServiceOverview from './components/ServiceOverview';
import FeaturedArticles from './components/FeaturedArticles';
import TestimonialSection from './components/TestimonialSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '女大学生的沙龙室 - 首页',
    description: '专为在校女大学生打造的专属美发、美妆与美容体验空间。提供平价时尚发型设计、护肤造型一站式服务。',
    url: 'https://readdy.ai',
    isPartOf: {
      '@type': 'WebSite',
      name: '女大学生的沙龙室',
      url: 'https://readdy.ai',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <ServiceOverview />
        <FeaturedArticles />
        <TestimonialSection />
        <CtaSection />
      </main>
      <Footer />
    </>
  );
}